export default function getPath(path) {
  return `/:lang${path}`;
}
